import React from 'react'
import HTag from '@/lib/HTag'
import Richtext from '@/lib/rt/Richtext'
import Employee from './Employee'
import CTA from '@/lib/CTA'
import clsx from 'clsx'

const EmployeeList = ({ heading, _rawRichtext, employees, ctas, pattern, blockId }) => (
	<section id={blockId} className={clsx('z-10', pattern)}>
		<div className="section-lg text-center">
			<header className="max-w-screen-sm mx-auto richtext mb-12">
				<HTag className="h1" {...heading} />
				<Richtext raw={_rawRichtext} />
			</header>

			<div className="grid sm:grid-cols-2 md:grid-cols-3 gap-16 <md:gap-y-8">
				{employees?.map((employee, key) => (
					<Employee {...employee} key={key} />
				))}
			</div>

			{!!ctas?.length && (
				<p className="flex flex-wrap items-center justify-center gap-4 mt-8">
					{ctas?.map((cta, key) => (
						<CTA {...cta} key={key} />
					))}
				</p>
			)}
		</div>
	</section>
)

export default EmployeeList
